import { toast } from 'react-toastify';
import * as api from '../../api/users.api';
import * as actionType from '../constants/users';

// get the list of users and update store
export const getUsers = (params) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });
  const response = await api.getUsers(params);

  if (response.ok) {
    return dispatch({ type: actionType.GET_USERS, payload: response.data.data });
  }

  return true;
};

export const getStaffMembers = () => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });
  const response = await api.getStaffMembers();

  if (response.ok) {
    return dispatch({ type: actionType.GET_STAFF_MEMBERS, payload: response.data.data });
  }

  return true;
};

// create new user and add to the store
export const addNewStaff = (data) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });
  const response = await api.createStaffMember(data);

  if (response.ok) {
    toast.success('You have successfully Create New Staff');
    return dispatch({ type: actionType.CREATE_STAFF_MEMBER, payload: response.data });
  }

  // eslint-disable-next-line no-unused-expressions
  response.data ? toast.error('Un-able to add staff please try again') : toast.error(response.problem);
  dispatch({ type: actionType.USER_LOADED });
  return 0;
};

// remove the user from the list
export const updateStaff = (data) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });

  const response = await api.updateStaffMember(data.id, data);

  if (response.ok) {
    toast.success('You have successfully update staff');
    return dispatch({ type: actionType.UPDATE_STAFF_MEMBER });
  }

  // eslint-disable-next-line no-unused-expressions
  response.data ? toast.error('Un-able to update staff please try again') : toast.error(response.problem);
  dispatch({ type: actionType.USER_LOADED });
  return 0;
};

// create new user and add to the store
export const addNewUser = (data) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });
  const response = await api.createUser(data);

  if (response.ok) {
    toast.success('You have successfully Create New User');
    return dispatch({ type: actionType.CREATE_USER, payload: response.data });
  }

  // eslint-disable-next-line no-unused-expressions
  response.data ? toast.error('Un-able to add user please try again') : toast.error(response.problem);
  dispatch({ type: actionType.USER_LOADED });
  return 0;
};

// remove the user from the list
export const removeUser = (userId) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });

  const response = await api.removeUser(userId);

  if (response.ok) {
    toast.success('You have successfully Remove User');
    return dispatch({ type: actionType.REMOVE_USER, payload: userId });
  }

  // eslint-disable-next-line no-unused-expressions
  response.data ? toast.error('Un-able to remove user please try again') : toast.error(response.problem);
  dispatch({ type: actionType.USER_LOADED });
  return 0;
};

// remove the user from the list
export const updateUser = (data) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });

  const response = await api.updateUser(data.id, data);

  if (response.ok) {
    toast.success('You have successfully Remove User');
    return dispatch({ type: actionType.UPDATE_USER });
  }

  // eslint-disable-next-line no-unused-expressions
  response.data ? toast.error('Un-able to remove user please try again') : toast.error(response.problem);
  dispatch({ type: actionType.USER_LOADED });
  return 0;
};

export const getUsersWallet = (params) => async (dispatch) => {
  dispatch({ type: actionType.USER_LOADING });
  const response = await api.getUsersWallet(params);

  if (response.ok) {
    return dispatch({ type: actionType.GET_USERS_WALLET, payload: response.data.data });
  }

  return true;
};

export const fetchDashboardOverview = () => async (dispatch) => {
  const response = await api.getDashboardOverview();

  if (response.ok && response.data?.success) {
    dispatch({ type: actionType.GET_DASHBOARD_OVERVIEW, payload: response.data.data });
  }

  return response;
};
